import { TablePagination } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { Card } from '../../../../components/article/Card';
import Loading from '../../../../components/info/Loading';
import DisplayError from '../../../../components/info/DisplayError';
import TableEmptyContent from '../../../../components/text/TableEmptyContent';
import { PathsLayouts } from '../../../../config/routes';
import { TranslationsKeys } from '../../../../locales/translations';
import { useCertificateOffers } from '../loaders/CertificateOffersLoader';

export function CertificatesCards() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_CERTIFICATES,
  );

  const { data, loading, error, query, updateQuery } = useCertificateOffers();

  if (loading) {
    return <Loading insideCard />;
  }

  if (error) {
    return (
      <DisplayError
        insideCard
        textBody={error.code}
        retryAction={() => updateQuery({ ...query })}
        loadingAction={loading}
      />
    );
  }

  if (!data || data.data.length === 0) {
    return (
      <div
        className="p-5"
        style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
      >
        <TableEmptyContent
          title={t('empty.title')}
          subtitle={t('empty.subtitle')}
        />
      </div>
    );
  }

  const { data: offers, total, total_pages: totalPages } = data;
  const currentPage = query.page ?? 1;
  const itemsPerPage = query.items_per_page ?? 12;

  return (
    <>
      <Row>
        {offers.map((offer) => {
          const percentage =
            offer.completionPercentage < 100
              ? offer.completionPercentage.toFixed(1)
              : Math.round(offer.completionPercentage);

          return (
            <Col md={4} lg={3} key={offer.ceAcademicOfferId} className="mb-4">
              <Card
                title={offer.studyPlanName}
                subtitle={`${offer.schoolName} - ${offer.campusName} - ${offer.scheduleName} - ${offer.modalityName}`}
                className="p-1"
                body={[
                  {
                    label: t('card.enrolled'),
                    value: offer.enrolledCount,
                  },
                  {
                    label: t('card.studying'),
                    value: offer.studyingCount,
                  },
                  {
                    label: t('card.completed'),
                    value: offer.completedCount,
                  },
                ]}
                markedText={{
                  label: t('card.completionPercentage'),
                  value: `${percentage}%`,
                }}
                to={`${PathsLayouts.continuousEducation}/certificates/${offer.ceAcademicOfferId}/students`}
              />
            </Col>
          );
        })}
      </Row>
      {totalPages > 1 && (
        <TablePagination
          pagination={{
            currentPage,
            itemsPerPage,
            onChangePage: (page) => {
              updateQuery({
                ...query,
                page,
              });
            },
            totalItems: total,
            totalPages,
          }}
        />
      )}
    </>
  );
}
